<template>
  <div :class="{ 'mt-30-px': !showNavbar }">
    <notifications />
    <navbar
      v-if="showNavbar"
      :docsName="docsName"
    />

    <ValidationObserver v-slot="{ invalid }">
      <div class="container-fluid">
        <!-- HEADER / AKTIONSLEISTE -->
        <div
          v-if="showNavbar"
          class="row"
        >
          <div class="col-xl-12">
            <div class="row">
              <div class="col-xl-12 block br-t-l-0 mb-3">
                <head-menu
                  :col="12"
                  class="d-xl-flex"
                  :headline="navbarTitel"
                />
                <div class="row mt-2 d-flex justify-content-between">
                  <div class="ml-4">
                    <button
                      v-shortkey.once="['ctrl', 's']"
                      class="btn btn-success mr-2"
                      :disabled="invalid"
                      @click="speichern"
                      @shortkey="speichern"
                    >
                      {{ $t('global.save') }}
                    </button>
                    <button
                      class="btn btn-primary mr-2"
                      @click="abbrechen"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-list"
                        class="mr-2"
                      />
                      {{ $t('global.tolist') }}
                    </button>
                  </div>
                  <div class="mr-4">
                    <button
                      v-if="
                        berechtigungen.m_umfragen.delete &&
                        editable &&
                        ausbildungsplan &&
                        ausbildungsplan.id
                      "
                      class="btn btn-danger"
                      @click="oeffneLoeschenModal"
                    >
                      <font-awesome-icon icon="fa-duotone fa-trash" />
                      <span>{{ $t('global.delete') }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- STAMMDATEN -->
        <container-headline
          :headline="$t('global.masterdata')"
          :col="2"
        />
        <div class="row mb-3">
          <div class="col-xl-12 block br-t-l-0">
            <div class="eingabe-panel-kopf p-3">
              <div class="row">
                <div class="col-xl-6">
                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      immediate
                      v-slot="{ passed }"
                    >
                      <input
                        v-model="ausbildungsplan.bezeichnung"
                        class="form-control"
                        :class="{ 'border-danger': !passed }"
                        :readonly="!editable"
                      />
                      <label :class="{ 'text-danger': !passed }">
                        {{ $t('global.designation') }}
                      </label>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="form-group">
                    <v-select
                      v-model="ausbildungsplan.abschluss"
                      class="w-100"
                      label="bezeichnung"
                      :options="abschluesse"
                      :disabled="!editable"
                    >
                      <span slot="no-options">
                        {{ $t('global.taptosearch') }}
                      </span>
                    </v-select>
                    <label>{{ $t('global.degree') }}</label>
                  </div>
                </div>
                <div class="col-xl-3 d-flex align-items-center">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      v-model="ausbildungsplan.cpVergabe"
                      id="cpVergabe"
                      class="form-check-input"
                      :disabled="!editable"
                    />
                    <label
                      class="form-check-label"
                      for="cpVergabe"
                    >
                      {{ $t('global.cpAward') }}
                    </label>
                  </div>
                  <div
                    v-if="ausbildungsplan.cpVergabe"
                    class="ml-4"
                    style="width: 130px"
                  >
                    <div class="form-group mb-0">
                      <input
                        v-model="ausbildungsplan.cp"
                        class="form-control"
                        :readonly="!editable"
                      />
                      <label>{{ $t('global.creditpoints') }}</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Regelsatz Vorlage (nur bei neuem Plan) -->
              <div
                v-if="!ausbildungsplan.id"
                class="row"
              >
                <div class="col-xl-5">
                  <div class="form-group mb-0">
                    <v-select
                      v-model="ausbildungsplan.regelsatz"
                      class="w-100"
                      label="bezeichnung"
                      :options="allStandardRegelsaetze"
                      :disabled="!editable"
                    >
                      <span slot="no-options">
                        {{ $t('global.taptosearch') }}
                      </span>
                    </v-select>
                    <label>
                      Regelsatz (Vorlage)
                      <span class="text-danger">*</span>
                    </label>
                  </div>
                </div>
                <div class="col-xl-7 d-flex align-items-end pb-1">
                  <div class="alert alert-info mb-0 py-2 w-100">
                    Bitte zuerst die Stammdaten speichern. Danach kann die
                    Promotionsstruktur erstellt werden.
                  </div>
                </div>
              </div>

              <!-- Regelsatz Anzeige (bei bestehendem Plan) -->
              <div
                v-else-if="ausbildungsplan.regelsatz"
                class="row"
              >
                <div class="col-xl-4">
                  <div class="form-group mb-0">
                    <input
                      class="form-control"
                      :value="ausbildungsplan.regelsatz.bezeichnung"
                      readonly
                    />
                    <label>Regelsatz</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- REGELSATZ BEARBEITEN -->
        <template
          v-if="
            ausbildungsplan.id &&
            ausbildungsplan.regelsatz &&
            ausbildungsplan.regelsatz.id
          "
        >
          <container-headline
            headline="Regelsatz"
            :col="2"
          />
          <div class="row mb-3">
            <div class="col-xl-12 block br-t-l-0">
              <div class="eingabe-panel-kopf p-3">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <v-select
                        v-model="ausbildungsplan.regelsatz.promotionsblockRegel"
                        class="w-100"
                        label="bezeichnung"
                        :options="allRegeln"
                        :disabled="!editable"
                      >
                        <span slot="no-options">
                          {{ $t('global.taptosearch') }}
                        </span>
                      </v-select>
                      <label>Promotionsblock (Standard)</label>
                      <small
                        v-if="regelDetails(ausbildungsplan.regelsatz.promotionsblockRegel)"
                        class="text-muted d-block mt-1"
                      >
                        {{ regelDetails(ausbildungsplan.regelsatz.promotionsblockRegel) }}
                      </small>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <v-select
                        v-model="ausbildungsplan.regelsatz.promotionsgruppeRegel"
                        class="w-100"
                        label="bezeichnung"
                        :options="allRegeln"
                        :disabled="!editable"
                      >
                        <span slot="no-options">
                          {{ $t('global.taptosearch') }}
                        </span>
                      </v-select>
                      <label>Promotionsgruppe (Standard)</label>
                      <small
                        v-if="regelDetails(ausbildungsplan.regelsatz.promotionsgruppeRegel)"
                        class="text-muted d-block mt-1"
                      >
                        {{ regelDetails(ausbildungsplan.regelsatz.promotionsgruppeRegel) }}
                      </small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12 d-flex justify-content-end">
                    <button
                      type="button"
                      class="btn btn-sm btn-success"
                      :disabled="!editable"
                      @click="speichernRegelsatz"
                    >
                      Regelsatz speichern
                      <font-awesome-icon
                        icon="fa-regular fa-floppy-disk"
                        class="ml-2"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- PROMOTIONSSTRUKTUR -->
        <template v-if="ausbildungsplan.id">
          <container-headline
            headline="Promotionsstruktur"
            :col="2"
          >
            <div class="d-flex align-items-center h-100">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                :disabled="!editable"
                @click="addPromotionsblock"
              >
                + Neuer Promotionsblock
              </button>
            </div>
          </container-headline>
          <div class="row mb-3">
            <div class="col-xl-12 block br-t-l-0">
              <div
                v-if="loadingPromotionsstruktur"
                class="eingabe-panel-kopf m-3 p-3"
              >
                <div class="alert alert-secondary mb-0">
                  Promotionsstruktur wird geladen…
                </div>
              </div>

              <template v-else>
                <!-- Keine Blöcke -->
                <div
                  v-if="
                    !ausbildungsplan.promotionsbloecke ||
                    !ausbildungsplan.promotionsbloecke.length
                  "
                  class="eingabe-panel-kopf m-3 p-3"
                >
                  <div class="alert alert-info mb-0">
                    Noch keine Promotionsblöcke vorhanden. Klicke auf „Neuer
                    Promotionsblock".
                  </div>
                </div>

                <!-- Tabs auf blauem Block-Hintergrund -->
                <ul
                  v-if="
                    ausbildungsplan.promotionsbloecke &&
                    ausbildungsplan.promotionsbloecke.length
                  "
                  class="nav nav-tabs px-3 pt-2 mb-0"
                >
                  <li
                    v-for="(pb, pbIndex) in ausbildungsplan.promotionsbloecke"
                    :key="pb.id || pb._key || pbIndex"
                    class="nav-item"
                  >
                    <a
                      href="javascript:void(0)"
                      class="nav-link"
                      :class="{ active: activeBlockIndex === pbIndex }"
                      @click="activeBlockIndex = pbIndex"
                    >
                      {{ pb.bezeichnung || 'Block ' + (pbIndex + 1) }}
                    </a>
                  </li>
                </ul>

                <!-- Aktiver Block: tab-container verbindet mit Tabs, eingabe-panel-kopf für Hintergrund -->
                <div
                  v-if="currentBlock"
                  class="tab-container eingabe-panel-kopf mx-3 mb-3 p-3"
                >
                  <!-- Block Stammdaten -->
                  <div class="row align-items-end mb-3">
                    <div class="col-xl-5">
                      <div class="form-group mb-0">
                        <input
                          v-model="currentBlock.bezeichnung"
                          type="text"
                          class="form-control"
                          placeholder="Bezeichnung Promotionsblock"
                          :disabled="!editable"
                        />
                        <label>Bezeichnung</label>
                      </div>
                    </div>
                    <div class="col-xl-1">
                      <div class="form-group mb-0">
                        <input
                          v-model.number="currentBlock.sortierung"
                          type="number"
                          class="form-control"
                          :disabled="!editable"
                        />
                        <label>Sort.</label>
                      </div>
                    </div>
                    <div
                      v-if="ausbildungsplan.cpVergabe"
                      class="col-xl-2"
                    >
                      <div class="form-group mb-0">
                        <input
                          v-model.number="currentBlock.minCp"
                          type="number"
                          class="form-control"
                          :disabled="!editable"
                        />
                        <label>Min. CP</label>
                      </div>
                    </div>
                    <div class="col-auto ml-auto d-flex">
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-success mr-2"
                        :disabled="!editable"
                        @click="savePromotionsblock(currentBlock)"
                      >
                        Block speichern
                        <font-awesome-icon
                          icon="fa-regular fa-floppy-disk"
                          class="ml-2"
                        />
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        :disabled="!editable"
                        @click="removePromotionsblock(activeBlockIndex)"
                      >
                        Block entfernen
                      </button>
                    </div>
                  </div>

                  <!-- Block Eigene Regel -->
                  <div class="row mb-4">
                    <div class="col-xl-12">
                      <div class="d-flex align-items-center">
                        <div class="form-check mr-3">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            :id="`block-eigenregel-${activeBlockIndex}`"
                            :checked="currentBlock._eigenRegel"
                            :disabled="!editable"
                            @change="
                              toggleEigeneRegelBlock(
                                currentBlock,
                                $event.target.checked
                              )
                            "
                          />
                          <label
                            class="form-check-label"
                            :for="`block-eigenregel-${activeBlockIndex}`"
                          >
                            Eigene Regel für diesen Block
                          </label>
                        </div>
                        <small
                          v-if="!currentBlock._eigenRegel"
                          class="text-muted"
                        >
                          — geerbt vom Regelsatz (Promotionsblock Standard)
                        </small>
                      </div>
                      <div
                        v-if="currentBlock._eigenRegel"
                        class="mt-2"
                        style="max-width: 400px"
                      >
                        <v-select
                          v-model="currentBlock.regel"
                          label="bezeichnung"
                          :options="allRegeln"
                          :disabled="!editable"
                        >
                          <span slot="no-options">
                            {{ $t('global.taptosearch') }}
                          </span>
                        </v-select>
                      </div>
                    </div>
                  </div>

                  <!-- Hint: Block noch nicht gespeichert -->
                  <div
                    v-if="!currentBlock.id"
                    class="alert alert-info"
                  >
                    Bitte zuerst den Block speichern. Danach können
                    Promotionsgruppen hinzugefügt werden.
                  </div>

                  <!-- PROMOTIONSGRUPPEN -->
                  <template v-if="currentBlock.id">
                    <div
                      class="d-flex align-items-center justify-content-between mb-2"
                    >
                      <small class="text-muted font-weight-bold text-uppercase">
                        Promotionsgruppen
                      </small>
                    </div>
                    <div
                      v-for="(pg, pgIndex) in currentBlock.promotionsgruppen ||
                      []"
                      :key="pg.id || pg._key || pgIndex"
                      class="card mb-2"
                    >
                      <!-- Gruppe Header -->
                      <div
                        class="card-header py-2 d-flex justify-content-between align-items-center"
                      >
                        <div class="d-flex align-items-center flex-grow-1 mr-3">
                          <b-button
                            class="m-0 mr-2"
                            variant="outline-primary"
                            size="sm"
                            @click="
                              togglePromotionsgruppe(
                                pgKey(
                                  currentBlock,
                                  activeBlockIndex,
                                  pg,
                                  pgIndex
                                )
                              )
                            "
                          >
                            <font-awesome-icon
                              :icon="
                                isPromotionsgruppeOpen(
                                  pgKey(
                                    currentBlock,
                                    activeBlockIndex,
                                    pg,
                                    pgIndex
                                  )
                                )
                                  ? 'fa-chevron-up'
                                  : 'fa-chevron-down'
                              "
                            />
                          </b-button>
                          <input
                            v-model="pg.bezeichnung"
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Bezeichnung Promotionsgruppe"
                            :disabled="!editable"
                            style="max-width: 280px"
                          />
                        </div>
                        <div class="d-flex align-items-center">
                          <div
                            v-if="ausbildungsplan.cpVergabe"
                            class="input-group input-group-sm mr-2"
                            style="width: 110px"
                          >
                            <div class="input-group-prepend">
                              <span class="input-group-text">CP</span>
                            </div>
                            <input
                              v-model.number="pg.minCp"
                              type="number"
                              class="form-control"
                              :disabled="!editable"
                            />
                          </div>
                          <div
                            class="input-group input-group-sm mr-3"
                            style="width: 130px"
                          >
                            <div class="input-group-prepend">
                              <span class="input-group-text">Gew.</span>
                            </div>
                            <input
                              v-model.number="pg.gewichtung"
                              type="number"
                              step="0.1"
                              class="form-control"
                              :disabled="!editable"
                            />
                          </div>
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-success mr-1"
                            :disabled="!editable"
                            @click="savePromotionsgruppe(currentBlock, pg)"
                            title="Gruppe speichern"
                          >
                            Speichern
                            <font-awesome-icon
                              icon="fa-regular fa-floppy-disk"
                              class="ml-1"
                            />
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-danger"
                            :disabled="!editable"
                            @click="
                              removePromotionsgruppe(currentBlock, pgIndex)
                            "
                            title="Gruppe entfernen"
                          >
                            <font-awesome-icon icon="fa-duotone fa-trash" />
                          </button>
                        </div>
                      </div>

                      <!-- Gruppe Body -->
                      <div
                        v-show="
                          isPromotionsgruppeOpen(
                            pgKey(currentBlock, activeBlockIndex, pg, pgIndex)
                          )
                        "
                        class="card-body"
                      >
                        <!-- Gruppe Eigene Regel -->
                        <div class="mb-3">
                          <div class="d-flex align-items-center">
                            <div class="form-check mr-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                :id="`pg-eigenregel-${activeBlockIndex}-${pgIndex}`"
                                :checked="pg._eigenRegel"
                                :disabled="!editable || !pg.id"
                                @change="
                                  toggleEigeneRegelGruppe(
                                    pg,
                                    $event.target.checked
                                  )
                                "
                              />
                              <label
                                class="form-check-label"
                                :for="`pg-eigenregel-${activeBlockIndex}-${pgIndex}`"
                              >
                                Eigene Regel für diese Gruppe
                              </label>
                            </div>
                            <small
                              v-if="!pg._eigenRegel"
                              class="text-muted"
                            >
                              — geerbt vom Regelsatz (Promotionsgruppe Standard)
                            </small>
                          </div>
                          <div
                            v-if="pg._eigenRegel"
                            class="mt-2"
                            style="max-width: 400px"
                          >
                            <v-select
                              v-model="pg.regel"
                              label="bezeichnung"
                              :options="allRegeln"
                              :disabled="!editable || !pg.id"
                            >
                              <span slot="no-options">
                                {{ $t('global.taptosearch') }}
                              </span>
                            </v-select>
                          </div>
                        </div>

                        <!-- Hint: Gruppe noch nicht gespeichert -->
                        <div
                          v-if="!pg.id"
                          class="alert alert-info mb-2"
                        >
                          Bitte zuerst die Gruppe speichern. Danach können
                          Module hinzugefügt werden.
                        </div>

                        <!-- Modul-Tabelle -->
                        <template v-if="pg.id">
                          <small
                            class="text-muted font-weight-bold text-uppercase d-block mb-1"
                          >
                            Module
                          </small>
                          <table
                            v-if="pg.module && pg.module.length"
                            class="table table-sm table-bordered mb-2"
                          >
                            <thead class="thead-light">
                              <tr>
                                <th>Bezeichnung</th>
                                <th v-if="ausbildungsplan.cpVergabe">CP</th>
                                <th>Noteneingabetyp</th>
                                <th v-if="ausbildungsplan.cpVergabe"></th>
                                <th style="width: 80px"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(modul, mIndex) in pg.module"
                                :key="modul._key || modul.id || mIndex"
                              >
                                <td class="align-middle text-dark">
                                  {{ modul.bezeichnung }}
                                </td>
                                <td
                                  v-if="ausbildungsplan.cpVergabe"
                                  class="align-middle text-dark"
                                >
                                  {{ modul.cp != null ? modul.cp : '—' }}
                                </td>
                                <td class="align-middle text-dark">
                                  {{ getNotenTypBezeichnung(modul) || '—' }}
                                </td>
                                <td
                                  v-if="ausbildungsplan.cpVergabe"
                                  class="align-middle text-dark"
                                >
                                  <template v-if="modul.dynamischeVergabe">
                                    <span class="badge badge-info mr-1">Dynamisch</span>
                                    <small>min. {{ modul.minCp != null ? modul.minCp : '—' }} CP</small>
                                  </template>
                                  <span v-else>Schwellenwert {{ getVergabeInfo(modul) }}</span>
                                </td>
                                <td class="text-right align-middle">
                                  <button
                                    type="button"
                                    class="btn btn-sm btn-outline-primary mr-1"
                                    :disabled="!modul.id"
                                    @click="goToModul(modul.id)"
                                    title="Modul bearbeiten"
                                  >
                                    <font-awesome-icon
                                      icon="fa-solid fa-up-right-from-square"
                                    />
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-sm btn-outline-danger"
                                    :disabled="!editable"
                                    @click="
                                      removeModul(currentBlock, pg, mIndex)
                                    "
                                    title="Modul entfernen"
                                  >
                                    <font-awesome-icon
                                      icon="fa-duotone fa-trash"
                                    />
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <button
                            type="button"
                            class="btn btn-sm btn-outline-primary"
                            :disabled="!editable"
                            @click="openModulModal(pg)"
                          >
                            + Modul hinzufügen
                          </button>
                        </template>
                      </div>
                    </div>

                    <!-- + Neue Gruppe -->
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary mt-2"
                      :disabled="!editable"
                      @click="addPromotionsgruppe(currentBlock)"
                    >
                      + Promotionsgruppe hinzufügen
                    </button>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>

      <unsaved-changes-modal
        @discard="handleDiscard"
        @stay="handleStay"
        :saveFunction="invalid == true ? null : speichern"
      />
    </ValidationObserver>

    <!-- Modul hinzufügen Modal -->
    <modul-hinzufuegen-modal
      :show.sync="modulModal.show"
      :pg="modulModal.pg"
      :cpVergabe="ausbildungsplan.cpVergabe"
      :noteneingabetypen="noteneingabetypen"
      :anzeigemodi="anzeigemodi"
      :allModuleOptions="allModuleOptions"
      @saved="onModulSaved"
    />

    <loading-overlay v-show="loading" />
    <loeschen-modal
      id="ausbildungsplan-loeschen-modal"
      @confirmed="ausbildungsplanLoeschen"
    />
  </div>
</template>

<script>
  import HeadMenu from '@/components/HeadMenu'
  import ContainerHeadline from '@/components/ContainerHeadline'
  import Navbar from '@/components/Navbar'
  import { apiErrorToAlert } from '@/utils/Errorhandler'
  import AppApi from '@/api/AppApi'
  import store from '@/store'
  import page from '@/mixins/Page'
  import ChangeWatcherNew from '@/mixins/ChangewatcherNew'
  import UnsavedChangesModal from '@/components/Modals/UnsavedChangesModal.vue'
  import LoeschenModal from '@/components/Modals/LoeschenModal'
  import { LADE_AUSWAHLWERTE_NOTEN } from '@/store/noten/actions.type'
  import { LADE_AUSWAHLWERTE_ANMELDUNG } from '@/store/anmeldung/actions.type'
  import ModulHinzufuegenModal from './components/ModulHinzufuegenModal.vue'

  const MODULLISTE_PATH = 'liste-modul'
  const MODUL_PATH = 'modul'
  const AUSBILDUNGSPLAN_PATH = 'ausbildungsplan'
  const PROMOTIONSBLOCK_PATH = 'promotionsblock'
  const PROMOTIONSGRUPPE_PATH = 'promotionsgruppe'
  const STANDARD_REGELSATZ_LISTE_PATH = 'standard-regelsatz-liste'
  const REGELSATZ_PATH = 'regelsatz'
  const REGELLISTE_PATH = 'liste-regel'

  const PARAM_AUSBILDUNGSPLAN_ID = 'id'
  const PARAM_PROMOTIONSBLOCK_ID = 'promotionsblockId'

  export default {
    name: 'Ausbildungsplan',
    components: {
      HeadMenu,
      Navbar,
      ContainerHeadline,
      LoeschenModal,
      UnsavedChangesModal,
      ModulHinzufuegenModal,
    },
    mixins: [page, ChangeWatcherNew],
    store,
    props: {
      id: { type: String, default: null },
      anzeige: { type: Number, default: 0 },
    },
    data() {
      return {
        editable: true,
        ausbildungsplan: {
          bezeichnung: '',
          cpVergabe: false,
          cp: null,
          abschluss: null,
          regelsatz: null,
          promotionsbloecke: [],
        },
        activeBlockIndex: 0,
        pgOpen: {},
        allModuleOptions: [],
        allStandardRegelsaetze: [],
        allRegeln: [],
        loadingPromotionsstruktur: false,
        modulModal: {
          show: false,
          pg: null,
        },
      }
    },
    computed: {
      navbarTitel() {
        const hasId =
          (this.ausbildungsplan && this.ausbildungsplan.id) || this.id
        return hasId ? 'Ausbildungsplan' : 'Neuer Ausbildungsplan'
      },
      noteneingabetypen() {
        return this.$store.state.noten.noteneingabetypen
      },
      anzeigemodi() {
        return this.$store.state.noten.ansichtsmodi
      },
      abschluesse() {
        return this.$store.state.anmeldung.abschluesse
      },
      currentBlock() {
        if (!this.ausbildungsplan || !this.ausbildungsplan.promotionsbloecke)
          return null
        return (
          this.ausbildungsplan.promotionsbloecke[this.activeBlockIndex] || null
        )
      },
    },
    watch: {
      id(newVal, oldVal) {
        if (newVal && newVal !== oldVal) this.initLoad()
      },
      async activeBlockIndex() {
        if (!this.ausbildungsplan || !this.ausbildungsplan.id) return
        await this.reloadActiveBlockChildren()
      },
      allRegeln() {
        // Once the rule list is loaded, normalize all regel references so the
        // v-select can match the selected value against its options list.
        this.normalizeAllRegelRefs()
        this.normalizeRegelsatzRegeln()
      },
    },
    created() {
      this.initLoad()
      this.loadAllStandardRegelsaetze()
      this.loadAllRegeln()
    },
    mounted() {
      this.$store.dispatch(`noten/${LADE_AUSWAHLWERTE_NOTEN}`)
      this.$store.dispatch(`anmeldung/${LADE_AUSWAHLWERTE_ANMELDUNG}`)
    },
    methods: {
      // -----------------------
      // Init / Load
      // -----------------------
      async initLoad() {
        try {
          this.loading = true
          this.loadingPromotionsstruktur = false

          if (this.id) {
            await this.loadAusbildungsplanMaster(this.id)
            await this.loadPromotionsbloecke()
            this.activeBlockIndex = 0
            await this.reloadActiveBlockChildren()
            await this.loadAllModuleOptions()
          } else {
            this.initializeNewAusbildungsplan()
          }
        } catch (e) {
          this.$notify(apiErrorToAlert(e))
        } finally {
          this.loading = false
        }
      },

      initializeNewAusbildungsplan() {
        this.ausbildungsplan = {
          bezeichnung: '',
          cpVergabe: false,
          cp: null,
          abschluss: null,
          regelsatz: null,
          promotionsbloecke: [],
        }
        this.activeBlockIndex = 0
        this.allModuleOptions = []
      },

      async loadAusbildungsplanMaster(id) {
        const resp = await AppApi.get(`${AUSBILDUNGSPLAN_PATH}/`, {
          params: { id },
        })
        this.ausbildungsplan = resp.data || {}
        if (!this.ausbildungsplan.promotionsbloecke)
          this.$set(this.ausbildungsplan, 'promotionsbloecke', [])
      },

      async loadPromotionsbloecke() {
        this.loadingPromotionsstruktur = true
        try {
          const resp = await AppApi.get(`${PROMOTIONSBLOCK_PATH}/`, {
            params: { [PARAM_AUSBILDUNGSPLAN_ID]: this.ausbildungsplan.id },
          })
          const list = Array.isArray(resp.data) ? resp.data : []
          list.forEach((pb) => {
            pb.promotionsgruppen = []
            pb._key = pb._key || `pb-${pb.id || Date.now()}-${Math.random()}`
            pb._eigenRegel = pb.regel != null
            this.normalizeRegelRef(pb)
          })
          this.$set(this.ausbildungsplan, 'promotionsbloecke', list)
        } finally {
          this.loadingPromotionsstruktur = false
        }
      },

      async reloadActiveBlockChildren() {
        const pb = this.currentBlock
        if (!pb || !pb.id) {
          if (pb && !pb.promotionsgruppen)
            this.$set(pb, 'promotionsgruppen', [])
          return
        }
        this.loadingPromotionsstruktur = true
        try {
          await this.loadPromotionsgruppenForBlock(pb)
        } finally {
          this.loadingPromotionsstruktur = false
        }
      },

      async loadPromotionsgruppenForBlock(pb) {
        const resp = await AppApi.get(`${PROMOTIONSGRUPPE_PATH}/`, {
          params: { [PARAM_PROMOTIONSBLOCK_ID]: pb.id },
        })
        const list = Array.isArray(resp.data) ? resp.data : []
        list.forEach((pg) => {
          pg._key = pg._key || `pg-${pg.id || Date.now()}-${Math.random()}`
          if (!Array.isArray(pg.module)) pg.module = []
          pg._eigenRegel = pg.regel != null
          if (!pg.gewichtung) pg.gewichtung = 1.0
          this.normalizeRegelRef(pg)
          this.decorateLoadedModules(pg)
        })
        this.$set(pb, 'promotionsgruppen', list)
      },

      decorateLoadedModules(pg) {
        pg.module = (pg.module || []).map((m) => {
          const moduleObj = m && m.modul ? m.modul : m
          return {
            ...moduleObj,
            _key:
              moduleObj._key ||
              `m-${moduleObj.id || Date.now()}-${Math.random()}`,
            _mode: 'linked',
          }
        })
      },

      async loadAllModuleOptions() {
        const resp = await AppApi.get(`${MODULLISTE_PATH}/`, {
          params: { page: 0, count: 50 },
        })
        const list = Array.isArray(resp.data) ? resp.data : []
        this.allModuleOptions = list.map((x) => (x && x.modul ? x.modul : x))
      },

      async loadAllStandardRegelsaetze() {
        try {
          const resp = await AppApi.get(`${STANDARD_REGELSATZ_LISTE_PATH}/`)
          this.allStandardRegelsaetze = Array.isArray(resp.data)
            ? resp.data
            : []
        } catch (e) {
          // silently fail
        }
      },

      async loadAllRegeln() {
        try {
          const resp = await AppApi.get(`${REGELLISTE_PATH}/`, {
            params: { count: 1000 },
          })
          this.allRegeln = resp.data || []
        } catch (e) {
          // silently fail
        }
      },

      async speichernRegelsatz() {
        if (this.loading) return
        if (
          !this.ausbildungsplan.regelsatz ||
          !this.ausbildungsplan.regelsatz.id
        )
          return
        try {
          this.loading = true
          const resp = await AppApi.put(
            `${REGELSATZ_PATH}/`,
            this.ausbildungsplan.regelsatz
          )
          this.ausbildungsplan.regelsatz = resp.data
          this.normalizeRegelsatzRegeln()
          this.$notify({
            type: 'success',
            title: this.$t('global.actionsuccessful'),
            text: 'Regelsatz gespeichert.',
          })
        } catch (e) {
          this.$notify(apiErrorToAlert(e))
        } finally {
          this.loading = false
        }
      },

      // -----------------------
      // Navigation
      // -----------------------
      abbrechen() {
        this.$router.push({ name: 'einstellungen-ausbildungsplaeneliste' })
      },

      // -----------------------
      // Ausbildungsplan speichern
      // -----------------------
      async speichern() {
        if (this.loading) return

        if (
          !this.ausbildungsplan.id &&
          !this.id &&
          !this.ausbildungsplan.regelsatz
        ) {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: 'Bitte einen Regelsatz als Vorlage auswählen.',
          })
          return
        }

        try {
          this.loading = true
          const payload = this.stripUiFieldsFromAusbildungsplan(
            this.ausbildungsplan
          )

          if (!this.ausbildungsplan.id && !this.id) {
            const resp = await AppApi.post(`${AUSBILDUNGSPLAN_PATH}/`, payload)
            this.ausbildungsplan = resp.data || {}
            this.$notify({
              type: 'success',
              title: this.$t('global.actionsuccessful'),
              text: this.$t('global.questionairesavedsuccessfully'),
            })
            this.$router.replace({
              name: 'einstellungen-ausbildungsplan',
              params: { id: this.ausbildungsplan.id, anzeige: 0 },
            })
            await this.loadAllModuleOptions()
            if (!this.ausbildungsplan.promotionsbloecke)
              this.$set(this.ausbildungsplan, 'promotionsbloecke', [])
          } else {
            payload.id = this.ausbildungsplan.id || this.id
            const promotionsbloecke = this.ausbildungsplan.promotionsbloecke
            const resp = await AppApi.put(`${AUSBILDUNGSPLAN_PATH}/`, payload)
            this.ausbildungsplan = resp.data || this.ausbildungsplan
            if (!this.ausbildungsplan.promotionsbloecke)
              this.$set(
                this.ausbildungsplan,
                'promotionsbloecke',
                promotionsbloecke || []
              )
            this.$notify({
              type: 'success',
              title: this.$t('global.actionsuccessful'),
              text: this.$t('global.questionairesavedsuccessfully'),
            })
          }
        } catch (e) {
          this.$notify(apiErrorToAlert(e))
        } finally {
          this.loading = false
        }
      },

      oeffneLoeschenModal() {
        this.$bus.$emit('openLoeschenModal', 'ausbildungsplan-loeschen-modal')
      },

      async ausbildungsplanLoeschen() {
        try {
          const deleteId = this.ausbildungsplan.id || this.id
          if (!deleteId) return
          await AppApi.delete(`${AUSBILDUNGSPLAN_PATH}/`, { data: [deleteId] })
          this.$router.push({ name: 'einstellungen-ausbildungsplaeneliste' })
        } catch (e) {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: this.$t('global.ausbildungsplancouldnotbedeleted'),
          })
        }
      },

      // -----------------------
      // UI Toggle Gruppen
      // -----------------------
      pgKey(pb, pbIndex, pg, pgIndex) {
        const pbId = pb && pb.id ? pb.id : `pb-${pbIndex}`
        const pgId = pg && pg.id ? pg.id : `pg-${pgIndex}`
        return `${pbId}|${pgId}`
      },
      isPromotionsgruppeOpen(key) {
        return this.pgOpen[key] === true
      },
      togglePromotionsgruppe(key) {
        this.$set(this.pgOpen, key, !this.isPromotionsgruppeOpen(key))
      },

      // -----------------------
      // Eigene Regel Toggles
      // -----------------------
      toggleEigeneRegelBlock(pb, checked) {
        this.$set(pb, '_eigenRegel', checked)
        if (!checked) this.$set(pb, 'regel', null)
      },
      toggleEigeneRegelGruppe(pg, checked) {
        this.$set(pg, '_eigenRegel', checked)
        if (!checked) this.$set(pg, 'regel', null)
      },

      // -----------------------
      // CRUD Promotionsblock
      // -----------------------
      addPromotionsblock() {
        if (!this.ausbildungsplan.id) {
          this.$notify({
            type: 'warn',
            title: this.$t('global.actionfailed'),
            text: 'Bitte zuerst den Ausbildungsplan speichern.',
          })
          return
        }
        if (!this.ausbildungsplan.promotionsbloecke)
          this.$set(this.ausbildungsplan, 'promotionsbloecke', [])

        const block = {
          id: null,
          bezeichnung: '',
          minCp: 0,
          sortierung: (this.ausbildungsplan.promotionsbloecke.length + 1) * 10,
          regel: null,
          promotionsgruppen: [],
          ausbildungsplanId: this.ausbildungsplan.id,
          _key: `pb-tmp-${Date.now()}-${Math.random()}`,
          _eigenRegel: false,
        }
        this.ausbildungsplan.promotionsbloecke.push(block)
        this.activeBlockIndex =
          this.ausbildungsplan.promotionsbloecke.length - 1
      },

      async savePromotionsblock(pb) {
        if (this.loading) return
        if (!this.ausbildungsplan.id) return
        try {
          this.loading = true
          const payload = this.stripUiFields(pb)

          const resp = pb.id
            ? await AppApi.put(`${PROMOTIONSBLOCK_PATH}/`, payload)
            : await AppApi.post(`${PROMOTIONSBLOCK_PATH}/`, payload)

          Object.assign(pb, resp.data || {})
          pb._eigenRegel = pb.regel != null
          this.normalizeRegelRef(pb)
          if (!pb.promotionsgruppen) this.$set(pb, 'promotionsgruppen', [])

          this.$notify({
            type: 'success',
            title: this.$t('global.actionsuccessful'),
            text: 'Promotionsblock gespeichert.',
          })
        } catch (e) {
          this.$notify(apiErrorToAlert(e))
        } finally {
          this.loading = false
        }
      },

      async removePromotionsblock(index) {
        const pb = (this.ausbildungsplan.promotionsbloecke || [])[index]
        if (!pb) return

        if (!pb.id) {
          this.ausbildungsplan.promotionsbloecke.splice(index, 1)
          this.activeBlockIndex = Math.max(0, this.activeBlockIndex - 1)
          return
        }

        try {
          await AppApi.delete(`${PROMOTIONSBLOCK_PATH}/`, { data: [pb.id] })
          this.ausbildungsplan.promotionsbloecke.splice(index, 1)
          if (
            this.activeBlockIndex >=
            this.ausbildungsplan.promotionsbloecke.length
          )
            this.activeBlockIndex = Math.max(
              0,
              this.ausbildungsplan.promotionsbloecke.length - 1
            )
        } catch (e) {
          this.$notify(apiErrorToAlert(e))
        }
      },

      // -----------------------
      // CRUD Promotionsgruppe
      // -----------------------
      addPromotionsgruppe(pb) {
        if (!pb || !pb.id) return
        if (!pb.promotionsgruppen) this.$set(pb, 'promotionsgruppen', [])
        pb.promotionsgruppen.push({
          id: null,
          bezeichnung: '',
          minCp: 0,
          gewichtung: 1.0,
          regel: null,
          module: [],
          _key: `pg-tmp-${Date.now()}-${Math.random()}`,
          _eigenRegel: false,
        })
      },

      async savePromotionsgruppe(pb, pg) {
        if (this.loading) return
        if (!pb || !pb.id) return
        try {
          this.loading = true
          const payload = this.stripUiFields(pg)
          payload[PARAM_PROMOTIONSBLOCK_ID] = pb.id

          const resp = pg.id
            ? await AppApi.put(`${PROMOTIONSGRUPPE_PATH}/`, payload)
            : await AppApi.post(`${PROMOTIONSGRUPPE_PATH}/`, payload)

          Object.assign(pg, resp.data || {})
          pg._eigenRegel = pg.regel != null
          this.normalizeRegelRef(pg)
          if (!Array.isArray(pg.module)) this.$set(pg, 'module', [])
          this.decorateLoadedModules(pg)

          this.$notify({
            type: 'success',
            title: this.$t('global.actionsuccessful'),
            text: 'Promotionsgruppe gespeichert.',
          })
        } catch (e) {
          this.$notify(apiErrorToAlert(e))
        } finally {
          this.loading = false
        }
      },

      async removePromotionsgruppe(pb, index) {
        const pg = (pb.promotionsgruppen || [])[index]
        if (!pg) return
        if (!pg.id) {
          pb.promotionsgruppen.splice(index, 1)
          return
        }
        try {
          await AppApi.delete(`${PROMOTIONSGRUPPE_PATH}/`, { data: [pg.id] })
          pb.promotionsgruppen.splice(index, 1)
        } catch (e) {
          this.$notify(apiErrorToAlert(e))
        }
      },

      // -----------------------
      // Modul Modal
      // -----------------------
      openModulModal(pg) {
        this.modulModal.pg = pg
        this.modulModal.show = true
      },

      async onModulSaved() {
        if (!this.currentBlock) return
        await this.loadPromotionsgruppenForBlock(this.currentBlock)
      },

      // -----------------------
      // Modul entfernen
      // -----------------------
      async removeModul(pb, pg, index) {
        const modul = (pg.module || [])[index]
        if (!modul) return

        if (!modul.id || modul._mode !== 'linked') {
          pg.module.splice(index, 1)
          return
        }

        try {
          await AppApi.delete(`${MODUL_PATH}/`, {
            params: { remove: true },
            data: { fachId: modul.id, promotionsgruppeId: pg.id },
          })
          await this.loadPromotionsgruppenForBlock(pb)
        } catch (e) {
          this.$notify(apiErrorToAlert(e))
        }
      },

      goToModul(id) {
        if (!id) return
        this.$router.push({ name: 'einstellungen-modul', params: { id } })
      },

      // -----------------------
      // Regel Normalisierung
      // -----------------------
      /**
       * Replace obj.regel with the matching allRegeln item (by ID) so that
       * v-select can highlight the correct option in its dropdown.
       * The backend returns regel as a different DTO shape (SimpleDTO or
       * RegelDTO with snake_case keys) while allRegeln contains RegelListeDTO
       * objects (camelCase). Without this, vue-select cannot match the two.
       */
      normalizeRegelRef(obj) {
        if (!obj || !obj.regel || !obj.regel.id) return
        const matched = (this.allRegeln || []).find((r) => r.id === obj.regel.id)
        if (matched) this.$set(obj, 'regel', matched)
      },

      normalizeAllRegelRefs() {
        const blocks = this.ausbildungsplan?.promotionsbloecke || []
        blocks.forEach((pb) => {
          this.normalizeRegelRef(pb)
          ;(pb.promotionsgruppen || []).forEach((pg) => this.normalizeRegelRef(pg))
        })
      },

      /**
       * Replace regelsatz regel references with the matching allRegeln item
       * (by ID) so that v-select can highlight the correct option and field
       * names are consistent (camelCase RegelListeDTO).
       */
      normalizeRegelsatzRegeln() {
        const rs = this.ausbildungsplan?.regelsatz
        if (!rs) return
        const fields = ['promotionsblockRegel', 'promotionsgruppeRegel']
        fields.forEach((field) => {
          const regel = rs[field]
          if (regel && regel.id) {
            const matched = (this.allRegeln || []).find((r) => r.id === regel.id)
            if (matched) this.$set(rs, field, matched)
          }
        })
      },

      /**
       * Returns a formatted string of the effective conditions of a regel,
       * excluding Anwesenheit. Handles both snake_case (RegelDTO) and
       * camelCase (RegelListeDTO) field names.
       */
      regelDetails(regel) {
        if (!regel) return null
        const parts = []
        const minNote = regel.minNote ?? regel.min_note
        const anzahlUngenuegende =
          regel.anzahlUngenuegende ?? regel.anzahl_ungenuegende
        const notendurchschnitt = regel.notendurchschnitt
        const textwahl = regel.textwahlWert ?? regel.textwahl_wert

        if (minNote != null) parts.push(`Min. Note: ${minNote}`)
        if (anzahlUngenuegende != null)
          parts.push(`Max. Ungenügende: ${anzahlUngenuegende}`)
        if (notendurchschnitt != null)
          parts.push(`Notendurchschnitt: ${notendurchschnitt}`)
        if (textwahl && textwahl.bezeichnung)
          parts.push(`Textwahl: ${textwahl.bezeichnung}`)

        return parts.length ? parts.join(' · ') : null
      },

      // -----------------------
      // Noteneingabetyp Helfer
      // -----------------------
      getNotenTyp(modul) {
        if (!modul || !modul.noteneingabeTypId) return null
        return (
          (this.noteneingabetypen || []).find(
            (x) => x.id === modul.noteneingabeTypId
          ) || null
        )
      },

      getNotenTypBezeichnung(modul) {
        return this.getNotenTyp(modul)?.bezeichnung || null
      },

      getAnzeigemodus(modul) {
        if (!modul || !modul.anzeigemodusId) return null
        return (this.anzeigemodi || []).find((x) => x.id === modul.anzeigemodusId) || null
      },

      getVergabeInfo(modul) {
        if (!modul) return '—'
        const sw = modul.schwellenwert
        if (sw == null || sw === '') return '—'
        const am = this.getAnzeigemodus(modul)
        if (am?.bezeichnung === 'Prozent') return `${sw}%`
        if (am?.bezeichnung === 'Punkte') return `${sw} Pkt.`
        return `${sw}`
      },

      // -----------------------
      // Payload Helfer
      // -----------------------
      stripUiFieldsFromAusbildungsplan(ap) {
        const copy = { ...(ap || {}) }
        delete copy.promotionsbloecke
        delete copy._key
        delete copy._ui
        return copy
      },

      stripUiFields(obj) {
        const copy = { ...(obj || {}) }
        delete copy._key
        delete copy._mode
        delete copy._eigenRegel
        delete copy.promotionsgruppen
        delete copy.module
        return copy
      },
    },
  }
</script>

<style scoped>
  /* Aktiver Tab = sehr helles Blau (passend zum Inhaltsbereich eingabe-panel-kopf: #f5fbff)
   Inaktiver Tab = mittleres Blau (hebt sich vom Inhalt ab: #cfdee9) */
  .nav-tabs .nav-link {
    background-color: #cfdee9 !important;
    border-radius: 10px 10px 0 0 !important;
  }
  .nav-tabs .nav-link.active {
    background-color: #f5fbff !important;
  }

  /* eingabe-panel-kopf hat border-radius: 10px global — top-left muss 0 bleiben
   damit der Inhalt bündig unter dem aktiven Tab sitzt */
  .tab-container.eingabe-panel-kopf {
    border-top-left-radius: 0 !important;
  }
</style>
